module.exports = "/layout/app/images/bg-header.b0aebcf4.svg";